import { toast } from 'react-toastify';
import { categoryApi } from 'widgets/category/api/categoryApi';

type CategoryType = {
  product_category_id: number | 0;
  title_kk: string | null;
  title_ru: string | null;
  title_kg: string | null;
  title_uz: string | null;
  title_en: string | null;
  created_at: string | null;
  updated_at: string | null;
};

const getCategoryApi = categoryApi.injectEndpoints({
  endpoints: (builder) => ({
    getCategories: builder.query<CategoryType[], { search: string; page: number; size: number; order: number }>({
      query: ({ page, size, order }) => ({
        url: `/shop/admin/v1/product-category/get-product-categories?per_page=${size}&page=${page}&order=${order}`,
      }),
      providesTags: ['Category'],
    }),
    createCategory: builder.mutation({
      query: (body) => ({
        url: '/shop/admin/v1/product-category/create-product-category',
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
          'content-type': 'application/json',
        },
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = 'Произошла ошибка при создании категории';
        if (error) {
          toast.error(error_message.toString(), {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно создали новую категорию', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'Category', id: arg.id },
          { type: 'Category', id: 'ALL' },
        ];
      },
    }),
    deleteCategory: builder.mutation({
      query: (catId: number) => ({
        url: `/shop/admin/v1/product-category/delete-product-category-by-id?product_category_id=${catId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = 'Произошла ошибка при удалении категории';
        if (error) {
          toast.error(error_message.toString(), {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно удалили категорию', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'Categories', id: arg },
          { type: 'Category', id: 'ALL' },
        ];
      },
    }),
    changeCategory: builder.mutation({
      query: (body) => ({
        url: '/shop/admin/v1/product-category/update-product-category-by-id',
        method: 'PUT',
        body: JSON.stringify(body),
        headers: {
          'content-type': 'application/json',
        },
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = 'Произошла ошибка при обновлении категории';
        if (error) {
          toast.error(error_message.toString(), {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно обновили категорию', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'Category', id: arg.id },
          { type: 'Category', id: 'ALL' },
        ];
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetCategoriesQuery,
  useCreateCategoryMutation,
  useDeleteCategoryMutation,
  useChangeCategoryMutation,
} = getCategoryApi;
